import React from 'react';
import { useEffect } from 'react';
import { Modal, Input, Select, notification, Form, Space, Button } from 'antd';
import { post } from '../../utils/http'
import api from '../../utils/api'

const { Option } = Select;
const { confirm } = Modal;

export default function CreateNewUser(props) {

    const [username, setUserName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [confirmLoading, setConfirmLoading] = React.useState(false);
    const [merchantList, setMerchantList] = React.useState([]);
    const [isGetMerchantList, setIsGetMerchantList] = React.useState(false);
    const [merchantIds, setMerchantNames] = React.useState([]);
    const [isGetRoleList, setIsGetRoleList] = React.useState(false);
    const [roleList, setRoleList] = React.useState([]);
    const [roleId, setRoleId] = React.useState('');

    useEffect(() => {
        if (!isGetMerchantList) {
            post(api.queryAllMerchant).then(function (response) {
                setMerchantList(response.allMerchantInfos.allMerchantInfos)
                setIsGetMerchantList(true);
            }).catch(function (error) {
                console.log(error)
            })
        }
        if (!isGetRoleList) {
            post(api.queryAllRole).then(function (response) {
                setRoleList(response.allRoleInfos.allRoleInfos)
                setIsGetRoleList(true);
            }).catch(function (error) {
                console.log(error)
            })
        }
    }, [])

    const handleSubmit = () => {//submit button
        var ps = merchantIds.join(",")
        setConfirmLoading(true)
        const createData = { 
            username: username, 
            email: email, 
            merchantIds: ps,
            roleId: roleId,
            displayTrue: { style: { display: "inline-block" } },
            displayFalse: { style: { display: "none" } },
            modalFooter: {}
        }
        post(api.saveAndUpdateUser, createData).then(function (response) {
            notification['success']({
                message: 'Create successfully.',
            });
            props.closeCreateModal()
            props.handleSearch()
            setConfirmLoading(false)
        }).catch(function (error) {
            notification['error']({
                message: error,
            });
            setConfirmLoading(false)
        })
    }

    const handleCancle = () => {
        confirm({
            content: "Are you sure to close this modal?",
            onOk() {
                Modal.destroyAll();
                props.closeCreateModal();
            }
        });
    };

    const checkEmail = (value) => {
        if (value !== "" && !(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/.test(value))) {
            notification['warning']({
                message: 'Please input correct email!',
            });
        }
    }

    const setRoleIdFun = (value) => {
        if (value === 1 || value === 2) {
            props.hideMerchant()
        } else {
            props.showMerchant()
        }
        setRoleId(value)
    }

    return (
        <>
            <Modal
                destroyOnClose={true}
                title="Create User"
                visible={props.isOpenCreate}
                confirmLoading={confirmLoading}
                onCancel={handleCancle}
                footer={null}
            >
                <Form
                    name="create_user"
                    onFinish={handleSubmit}
                    labelCol={{ span: 7 }}
                    autoComplete="off"
                    >
                    <Form.Item
                        name="User Name"
                        label="User Name"
                        rules={[{ required: true, message: 'Please input User Name!' }]}
                    >
                        <Input placeholder="username" onChange={event => setUserName(event.target.value)} style={{ height: "36px", width: "300px" }} />
                    </Form.Item>
                    <Form.Item
                        name="Email"
                        label="Email"
                        rules={[{ required: true, message: 'Please input Email!' }]}
                    >
                        <Input placeholder="email" onBlur={event => checkEmail(event.target.value)} onChange={event => setEmail(event.target.value)} style={{ height: "36px", width: "300px" }} />
                    </Form.Item>
                    <Form.Item
                        name="Role"
                        label="Role"
                        rules={[{ required: true, message: 'Please select Role!' }]}
                    >
                        <Select
                            allowClear
                            placeholder="Please select"
                            style={{ height: "36px", width: "300px" }}
                            onChange={value => setRoleIdFun(value)}>
                                {roleList.map((item) => {
                                return <Option key={item.roleId} value={item.roleId}>{item.roleCode}</Option>
                            })}
                        </Select>
                    </Form.Item>
                    {/* {props.isShowMerchant &&<Form.Item
                        name="Merchant Name"
                        label="Merchant Name"
                    >
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="Please select"
                            value={merchantIds}
                            style={{ height: "36px", width: "300px" }}
                            onChange={value => setMerchantNames(value)}>
                                {merchantList.map((item) => {
                                return <Option key={item.merchantId} value={item.merchantId}>{item.merchantName}</Option>
                            })}
                        </Select>
                    </Form.Item>} */}
                    <Form.Item wrapperCol={{ offset: 16, span: 16 }}>
                        <Space>
                            <Button size="large" htmlType="button" onClick={handleCancle}>
                                Cancel
                            </Button>
                            <Button size="large" type="primary" htmlType="submit" >
                                OK
                            </Button>
                        </Space>
                    </Form.Item> 
                </Form>
            </Modal>
        </>
    )
}